const updateField = (type, payload) => ({
  type,
  ...payload,
});

export { updateField };
